import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Box,
  Breadcrumbs,
  FormControl,
  IconButton,
  Link,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import SupplierBasicInfo from "../../components/supplier/SupplierBasicInfo";
import SupplierTerms from "../../components/supplier/SupplierTerms";
import SupplierBank from "../../components/supplier/SupplierBank";
import SupplierAgreement from "../../components/supplier/SupplierAgreement";
import SupplierPenalty from "../../components/supplier/SupplierPenalty";
import { useLocation } from "react-router-dom";
import { externalgetApi } from "../../services/externalApis";
import { SUPPLIER_API_06 } from "../../api/ApiModel";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function CreateSupplier() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [value, setValue] = useState(0);
const [datasupbranch, setDatasupbranch] = useState(null);
  const location = useLocation();
  const { selectedItem, actionText } = location.state || {};

  const [supplierType, setSupplierType] = useState(
    selectedItem?.suptypecode === "2" ? "Cooperate" : "Individual"
  );

  const [suprefcode, setSuprefcode] = useState(selectedItem?.suprefcode || 0);

  const handleSupplierTypeChange = (event) => {
    setSupplierType(event.target.value);
  };

  useEffect(() => {
    setPageData({
      title: "Supplier Management",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  
    const fetchDatasupbranch = async () => {
      try {
        const result = await externalgetApi(SUPPLIER_API_06, "get", {
          suprefcode:selectedItem.suprefcode,
  
          STS: CON_STATUS_ACTIVE,
        });
  
        setDatasupbranch(result);
        console.log("result", result);
     
      } catch (err) {
       
    
      }
    };
  

   useEffect(() => {
    if (actionText === "Edit" && selectedItem) {
      fetchDatasupbranch(selectedItem.suprefcode);
    }
  }, [actionText, selectedItem]);

  useEffect(() => {
    if (selectedItem?.suptypecode) {
      setSupplierType(
        selectedItem.suptypecode == "2" ? "Cooperate" : "Individual"
      );
    }
  }, [selectedItem]);

  const goBackToView = () => {
    navigate("/vaddsupplier");
  };
  return (
    <>
      {" "}
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to All Items" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Supplier Management
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            New Supplier Account
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {" "}
                <Typography sx={styles.appbar_title}>
                  {actionText === "Edit"
                    ? "Edit Supplier Account"
                    : "New Supplier Account"}
                </Typography>
              </Typography>
            </Grid>
            <Grid
              item
              size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.box_right_align}
            >
              <FormControl
                sx={{ color: theme.palette.input_field.text }}
                disabled={actionText === "Edit"}
              >
                <RadioGroup
                  row
                  value={supplierType}
                  onChange={handleSupplierTypeChange}
                  name="supplier-type"
                >
                  <FormControlLabel
                    value="Individual"
                    control={<Radio />}
                    label="Individual Supplier"
                  />
                  <FormControlLabel
                    value="Cooperate"
                    control={<Radio />}
                    label="Cooperate Supplier"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </AppBar>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={styles.add_form_page_container}
        >
          {/* Tab panel */}
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Basic Information" {...a11yProps(0)} />
              <Tab
                label="Payment Terms"
                {...a11yProps(1)}
                disabled={suprefcode === 0}
              />
              <Tab
                label="Late Delivery Penalty"
                {...a11yProps(2)}
                disabled={suprefcode === 0}
              />
              <Tab
                label="Agreement & Contract"
                {...a11yProps(3)}
                disabled={suprefcode === 0}
              />
              <Tab
                label="Bank Details"
                {...a11yProps(4)}
                disabled={suprefcode === 0}
              />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <SupplierBasicInfo
              supplierType={supplierType}
              selectedItem={selectedItem}
              actionText={actionText}
              setSuprefcode={setSuprefcode} 
              suprefcode={suprefcode}
              // <-- pass this prop
            />
          </TabPanel>
          {suprefcode !== 0 && (
          <>
            <TabPanel value={value} index={1} dir={theme.direction} >
              <SupplierTerms />
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <SupplierPenalty />
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              <SupplierAgreement   suprefcode={suprefcode}setSuprefcode={setSuprefcode} />
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction}  setSuprefcode={setSuprefcode} >
               <SupplierBank suprefcode={suprefcode} setSuprefcode={setSuprefcode} />
            </TabPanel>
          </>
       )} 
        </Box>
        {/* <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          >
            Confirm
          </Button>
        </Box> */}
      </Box>
    </>
  );
}

export default CreateSupplier;
